import React from 'react';
import { DataList } from 'commons-ui';
import { LIST_ENTITY_NAMES } from '../../../../../settingsV2Constant';
import { columnConfigs, IPermissionSetDetails } from './listConfig';
import useService from './useService';

const PermissionsSetDetails: React.FC<any> = (props: IPermissionSetDetails) => {
	const { permissionsSetData } = props;
	const { getPermissionsSetDetails } = useService(permissionsSetData);

	return (
		<DataList
			fetchData={getPermissionsSetDetails}
			columnConfigs={columnConfigs}
			hideActions
			entity={LIST_ENTITY_NAMES.PERMISSIONS_SET}
			rowHeight={60}
		/>
	);
};

export default PermissionsSetDetails;
